export const BILLING_TIME_ZONE = "America/Bogota";

const DATE_ONLY = /^\d{4}-\d{2}-\d{2}$/;

const dayFormatter = new Intl.DateTimeFormat("en-CA", {
  timeZone: BILLING_TIME_ZONE,
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
});

export function billingDay(value: string | null | undefined): string | null {
  if (!value) return null;
  if (DATE_ONLY.test(value)) return value;
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return null;
  return dayFormatter.format(date);
}

export function billingDayAsLocalDate(value: string | null | undefined): Date | null {
  const day = billingDay(value);
  if (!day) return null;
  const [year, month, date] = day.split("-").map(Number);
  return new Date(year, month - 1, date);
}

export function billingDayStart(day: string): string {
  return new Date(`${day.slice(0, 10)}T00:00:00-05:00`).toISOString();
}
